import styled, { css } from 'styled-components';
import CTA from '../../atoms/CTA';
import { CopyStandardSkin } from '../../atoms/Copytext/CopytextSkins';
import { Headline700Skin } from '../../atoms/Headline/HeadlineSkins';
import { CopyStandard } from '../../atoms/Copytext';
import Icon from '../../atoms/Icon';
import { getThemeValueByName } from '~/helpers/getColors';

export const JobAlertContainer = styled.div`
  ${({ jobAdsCount, theme }) =>
    jobAdsCount !== 0 &&
    css`
      background: ${getThemeValueByName(theme, theme.hero.background)};
      position: relative;
      width: 100%;
      margin: 0 auto;
      padding: 66px 0;

      @media (${theme.jobAlert.mobileSwitch}) {
        padding: 44px 0 38px 0;
      }

      .richText span {
        color: ${theme.color.white500};
      }
    `};
`;

export const AlertHeadline = styled.h3`
  ${Headline700Skin};
  color: ${({ theme }) => theme.color.white500};
  margin-bottom: 16px;
`;

export const SubscribeDataProtectionText = styled(CopyStandard)`
  position: relative;
  a {
    color: inherit;
    transition: opacity 0.25s ease-out;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const AlertCopyText = styled(CopyStandard)`
  position: relative;
  a {
    color: inherit;
    transition: opacity 0.25s ease-out;

    &:hover {
      opacity: 0.8;
    }
  }

  ${({ state }) =>
    state !== '' &&
    css`
      padding: 10px 20px;
      display: flex;
      gap: 15px;
      align-items: center;
    `}

  ${({ state, theme, jobAdsCount }) =>
    state === 'success' &&
    css`
      color: ${jobAdsCount === 0
        ? theme.color.brandSuccess500
        : theme.color.white500} !important;
    `}

  ${({ state, theme }) =>
    state === 'error' &&
    css`
      cursor: pointer;
      background-color: ${theme.color.gray50};
      color: ${theme.color.brandDanger500} !important;
      border-bottom: 3px solid;
      margin-bottom: -3px;
    `}
`;

export const Filter = styled.span`
  font-weight: bold;
`;

export const FormContainer = styled.div`
  display: flex;

  @media (${({ theme }) => theme.jobAlert.mobileSwitch}) {
    flex-direction: column;
  }
`;

export const StyledInput = styled.input`
  ${CopyStandardSkin};
  color: ${({ theme }) => theme.color.primary800};
  flex-grow: 1;
  margin-right: 12px;
  padding: 1px 16px;
  border: none;

  @media (${({ theme }) => theme.jobAlert.mobileSwitch}) {
    width: 100%;
    height: 50px;
  }

  ::placeholder {
    color: ${({ theme }) => theme.color.primary800};
  }

  &:focus {
    border: 2px solid ${({ theme }) => theme.color.cta};
  }

  ${({ jobAdsCount, theme }) =>
    jobAdsCount === 0 &&
    css`
      background-color: ${theme.color.gray300};
    `};
`;

export const StyledCTA = styled(CTA)`
  button {
    span {
      margin: 0 auto;
    }
    @media (${({ theme }) => theme.jobAlert.mobileSwitch}) {
      margin-top: 25px;
      width: 100%;
    }
  }
`;

export const VerticalSeparator = styled.div`
  margin-bottom: ${({ size }) => size || '10px'};
`;

export const StyledIcon = styled(Icon)`
  color: ${({ theme, $status }) =>
    $status === 'success'
      ? theme.color.brandSuccess500
      : theme.color.brandDanger500} !important;
  width: 30px;
  height: 30px;
  background-color: white;
  padding: ${({ theme, $status }) =>
    $status === 'success' ? '8px' : '3px 8px 8px 8px'};
  border-radius: 50%;
`;
